export interface SidebarOptions {
  gd: boolean;
  tt: string;
  vd: boolean;
  af: string;
  ki: boolean;
  se: boolean;
  nv: boolean;
  adw: boolean;
  mt: boolean;
  eg: boolean;
  oa: boolean;
  ow: boolean;
  wc: boolean;
  bn: string;
  // Allow dynamic access to SelectedFilters keys when applying default values
  // from the backend (key-value pairs).
  [key: string]: string | boolean;
}

export interface CommonSearchFilterObj {
  SelectedFilters: SidebarOptions;
  scope: string | undefined;
  search: string;
  sort: number;
  nationwide: boolean;
  pageNo: number;
}

export const commonSearchFilterObj: CommonSearchFilterObj = {
  SelectedFilters: {
    gd: false,
    tt: '',
    vd: false,
    af: '10',
    ki: false,
    se: false,
    nv: false,
    adw: false,
    mt: false,
    eg: false,
    oa: false,
    ow: false,
    wc: false,
    bn: '',
  },
  scope: '',
  search: '',
  sort: 4,
  nationwide: false,
  pageNo: 1,
};

export function createFilterString(filters: SidebarOptions): string {
  const filterPairs = Object.entries(filters)
    .filter(([value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      let stringValue: string;
      if (typeof value === 'boolean') {
        stringValue = value ? 'true' : 'false';
      } else if (typeof value === 'number' || typeof value === 'string') {
        stringValue = encodeURIComponent(value.toString());
      } else {
        throw new Error(`Unsupported filter value type: ${typeof value}`);
      }
      return `${key}=${stringValue}`;
    });
  return filterPairs.join('&');
}

export const months = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december',
];

export function decryptedFilterString(filterObj: string) {
  const parsed = JSON.parse(filterObj) as Record<string, string>;

  for (const [key, value] of Object.entries(parsed)) {
    if (key === 'tt' || key === 'bn') {
      commonSearchFilterObj.SelectedFilters[key] = value;
    } else {
      commonSearchFilterObj.SelectedFilters[key] = JSON.parse(value);
    }
  }
}
